<template>
  <div class="board-box">
    <div style="margin-bottom: 0.5rem">
      <p class="text-title">客户风控管理</p>
    </div>
    <div class="grid-8 mb-1">
      <div class="card padding-bg">
        <p class="text-small">逾期客户数</p>
        <p class="text-big-title">
          {{ riskDashboard.overdueCustomer || 0
          }}<span v-html="imageByCompare(riskDashboard.overdueCustomer, riskDashboard.lastOverdueCustomer)"></span>
        </p>
        <p class="text-small" style="font-size: 12px">上月逾期客户数 {{ riskDashboard.lastOverdueCustomer || 0 }}</p>
      </div>
      <div class="card padding-bg">
        <p class="text-small">逾期金额（万元）</p>
        <p class="text-big-title">
          {{ formatThousandSeparator(riskDashboard.overdueAmount)
          }}<span v-html="imageByCompare(riskDashboard.overdueAmount, riskDashboard.lastOverdueAmount)"></span>
        </p>
        <p class="text-small" style="font-size: 12px">
          上月逾期金额 {{ formatThousandSeparator(riskDashboard.lastOverdueAmount) }}
        </p>
      </div>
      <div class="card padding-bg">
        <p class="text-small">逾期率</p>
        <p class="text-big-title">
          {{ riskDashboard.overdueRate
          }}<span v-html="imageByCompare(riskDashboard.overdueRate, riskDashboard.lastOverdueRate)"></span>
        </p>
        <p class="text-small" style="font-size: 12px">上月逾期率 {{ riskDashboard.lastOverdueRate }}</p>
      </div>
      <div class="card padding-bg">
        <p class="text-small">逾期60天以上金额环比</p>
        <p class="text-big-title">
          {{ riskDashboard.cdefPartRate
          }}<span v-html="imageByCompare(riskDashboard.cdefPartAmount, riskDashboard.lastCdefPartAmount)"></span>
        </p>
        <!-- <p class="text-small">上月逾期客户数 434</p> -->
      </div>
      <div class="card padding-bg">
        <p class="text-small">有额度客户代码数</p>
        <p class="text-big-title">{{ formatThousandSeparator(riskDashboard.haveQuotaCustomer) }}</p>
        <!-- <p class="text-small">上月逾期客户数 434</p> -->
      </div>
      <div class="card padding-bg">
        <p class="text-small">固定额度（万元）</p>
        <p class="text-big-title">{{ formatThousandSeparator(riskDashboard.fixedQuota) }}</p>
        <!-- <p class="text-small">上月逾期客户数 434</p> -->
      </div>
      <div class="card padding-bg">
        <p class="text-small">实际授信系数</p>
        <p class="text-big-title">
          {{ riskDashboard.creditCoefficient
          }}<span
            v-html="
              imageByCompare(
                convertPercentageToNumber(riskDashboard.creditCoefficient),
                convertPercentageToNumber(riskDashboard.lastCreditCoefficient)
              )
            "
          ></span>
        </p>
        <p class="text-small" style="font-size: 12px">上月 {{ riskDashboard.lastCreditCoefficient }}</p>
      </div>
      <div class="card padding-bg">
        <p class="text-small">已使用固定额度占比</p>
        <p class="text-big-title">
          {{ riskDashboard.usedQuotaRate
          }}<span
            v-html="
              imageByCompare(
                convertPercentageToNumber(riskDashboard.usedQuotaRate),
                convertPercentageToNumber(riskDashboard.lastUsedQuotaRate)
              )
            "
          ></span>
        </p>
        <p class="text-small" style="font-size: 12px">上月 {{ riskDashboard.lastUsedQuotaRate }}</p>
      </div>
    </div>
    <div class="grid-3 mb-1">
      <div class="card mb-1" style="padding: 10px 0">
        <div class="board-top-label mx-12">
          <div class="from-box">
          <p class="text-subtitle">各逾期账龄的逾期金额分布</p>
          <p class="text-subtitle" style="color: #5b687d; margin-left:6px;">单位：万元</p>
        </div>
          <div class="from-box">
            <a-radio-group v-model:value="overdueAmountTypeRef">
              <a-radio-button :value="1">表格</a-radio-button>
              <a-radio-button :value="2">饼状图</a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <BoardPieChart height="230px" :data="overdueAmountTypeList" v-if="overdueAmountTypeRef === 2" />
        <OverdueAmountTypeListView style="margin-top: 6px;" height="224px" :data="overdueAmountTypeListData" v-if="overdueAmountTypeRef === 1" />
      </div>
      <div class="card mb-1" style="padding: 10px 0">
        <div class="board-top-label mx-12">
          <p class="text-subtitle">各管控方式可用主体数量分布</p>
        </div>
        <BoardBarChart height="230px" :data="creditControlTypeList" />
      </div>
      <div class="card mb-1" style="padding: 10px 0">
        <div class="board-top-label mx-12">
          <p class="text-subtitle">各固定额度规则类型分布情况</p>
          <p class="text-subtitle" style="color: #5b687d">单位：万元</p>
        </div>
        <BoardPieChart height="230px" :showLabel="false" :data="fixedLimitRuleTypeList" />
      </div>
    </div>
    <div class="grid-2">
      <div class="card">
        <div class="board-top-label mx-12 pt-12">
          <p class="text-subtitle">客户逾期趋势</p>
          <div class="from-box">
            <a-select
              v-model:value="overdueRef.dataType"
              class="from-box mr-12"
              style="width: 100px"
              @change="fetchOverdue"
            >
              <a-select-option value="overdueRate">逾期率</a-select-option>
              <a-select-option value="overdueAmount">逾期金额</a-select-option>
              <a-select-option value="overdueCustomer">逾期客户代码数</a-select-option>
            </a-select>
            <a-date-picker
              v-model:value="yearOverdue"
              :allowClear="false"
              v-if="overdueRef.dateQueryType === 3"
              @change="fetchOverdue"
              picker="year"
            />
            <a-range-picker
              v-model:value="weakOverdue"
              :allowClear="false"
              v-if="overdueRef.dateQueryType === 2"
              picker="week"
              @change="fetchOverdue"
            />

            <a-date-picker
              v-model:value="dayOverdue"
              :allowClear="false"
              v-if="overdueRef.dateQueryType === 1"
              @change="fetchOverdue"
              picker="month"
            />

            <a-radio-group v-model:value="overdueRef.dateQueryType" style="margin-left: 20px" @change="fetchOverdue">
              <a-radio-button :value="1">天</a-radio-button>
              <a-radio-button :value="2">周</a-radio-button>
              <a-radio-button :value="3">月</a-radio-button>
            </a-radio-group>

            <a-radio-group v-model:value="overdueRef.apiType" style="margin-left: 20px" @change="fetchOverdue">
              <a-radio-button :value="1">时间</a-radio-button>
              <a-radio-button :value="2">业务员</a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <BoardLineChart height="280px" :data="overdueList" :isPercentageY="overdueRef.dataType === 1" />
      </div>
      <div class="card">
        <div class="board-top-label mx-12 pt-12">
          <a-radio-group v-model:value="creditRef.dataType" @change="fetchCredit">
            <a-radio-button :value="0">实际授信系数</a-radio-button>
            <a-radio-button :value="1">已使用固定额度占比</a-radio-button>
          </a-radio-group>
          <div class="from-box">
            <a-date-picker
              v-model:value="yearCredit"
              :allowClear="false"
              v-if="creditRef.dateQueryType === 3"
              @change="fetchCredit"
              picker="year"
            />
            <a-range-picker
              v-model:value="weakCredit"
              :allowClear="false"
              v-if="creditRef.dateQueryType === 2"
              picker="week"
              @change="fetchCredit"
            />

            <a-date-picker
              v-model:value="dayCredit"
              :allowClear="false"
              v-if="creditRef.dateQueryType === 1"
              @change="fetchCredit"
              picker="month"
            />

            <a-radio-group v-model:value="creditRef.dateQueryType" style="margin: 0 10px" @change="fetchCredit">
              <a-radio-button :value="1">天</a-radio-button>
              <a-radio-button :value="2">周</a-radio-button>
              <a-radio-button :value="3">月</a-radio-button>
            </a-radio-group>

            <a-radio-group v-model:value="creditRef.apiType" @change="fetchCredit">
              <a-radio-button :value="1">时间</a-radio-button>
              <a-radio-button :value="2">业务员</a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <BoardLineChart height="280px" :data="creditList" :isPercentageY="creditRef.dataType === 1" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BoardPieChart from '../componects/BoardPieChart.vue'
import BoardLineChart from '../componects/BoardLineChart.vue'
import OverdueAmountTypeListView from './componects/overdueAmountTypeListView.vue'
import BoardBarChart from '../componects/BoardBarChart.vue'
import { ref, onMounted, toRef, watch, PropType } from 'vue'
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import formatThousandSeparator from '@/utils/format'
import dayjs, { Dayjs } from 'dayjs'

const props = defineProps({
  formState: {
    type: Object as PropType<Object>
  }
})

const formState = toRef(props, 'formState')

watch(
  () => props.formState,
  (newValue) => {
    formState.value = newValue
    fetchData()
  }
)

const riskDashboard = ref({})
const overdueAmountTypeList = ref([])
const overdueAmountTypeListData = ref([])
const creditControlTypeList = ref([])
const fixedLimitRuleTypeList = ref([])
const fetchData = () => {
  request.post<AxiosResult, AxiosResult>('/fbu/api/report/region/risk/dashboard', formState.value).then((res) => {
    riskDashboard.value = res.data
  })

  request
    .post<AxiosResult, AxiosResult>('/fbu/api/report/region/risk/overdueAmountType', formState.value)
    .then((res) => {
      const { overdueAmountType } = res.data
      overdueAmountTypeList.value = [
        { name: '1-30天', value: overdueAmountType?.apartAmount || 0 },
        { name: '31-60天', value: overdueAmountType?.bpartAmount || 0 },
        { name: '61-90天', value: overdueAmountType?.cpartAmount || 0 },
        { name: '91-180天', value: overdueAmountType?.dpartAmount || 0 },
        { name: '181-360天', value: overdueAmountType?.epartAmount || 0 },
        { name: '360天以上', value: overdueAmountType?.fpartAmount || 0 }
      ]
    })

  request
    .post<AxiosResult, AxiosResult>('/fbu/api/report/region/risk/overdueAmountTypeList', formState.value)
    .then((res) => {
      overdueAmountTypeListData.value = res.data || []
    })

  request
    .post<AxiosResult, AxiosResult>('/fbu/api/report/region/risk/creditControlType', formState.value)
    .then((res) => {
      if (!res.data) return
      const value1 = props.formState.region.deptScopeInfo.map((employee: any) => {
        const item = res.data.find((ii: any) => ii.employeeNo === employee.employeeNo)
        const quantity = item?.creditControlType1 || 0
        const rate = item?.creditControlType1Rate || '0%'
        return {
          name: `${employee.employeeName}`,
          value: quantity,
          tooltip: `${props.formState.date.format('YYYY/MM')}<br>销售员：${
            employee.employeeName
          }<br>额度管控 <span style="font-weight: bolder;font-size: 16px">${quantity} ${rate}</span>`
        }
      })
      const value2 = props.formState.region.deptScopeInfo.map((employee: any) => {
        const item = res.data.find((ii: any) => ii.employeeNo === employee.employeeNo)
        const quantity = item?.creditControlType2 || 0
        const rate = item?.creditControlType2Rate || '0%'
        return {
          name: `${employee.employeeName}`,
          value: quantity,
          tooltip: `${props.formState.date.format('YYYY/MM')}<br>销售员：${
            employee.employeeName
          }<br>账期管控 <span style="font-weight: bolder;font-size: 16px">${quantity} ${rate}</span>`
        }
      })

      creditControlTypeList.value = [
        { name: '额度管控', value: value1 },
        { name: '账期管控', value: value2 }
      ]
    })

  request
    .post<AxiosResult, AxiosResult>('/fbu/api/report/region/risk/fixedLimitRuleType', formState.value)
    .then((res) => {
      const { fixedLimitRuleType } = res.data
      fixedLimitRuleTypeList.value = [
        { name: '申请金额-转运客户', value: fixedLimitRuleType?.transportQuota || 0 },
        { name: '申请金额-仓储新客', value: fixedLimitRuleType?.newStorageQuota || 0 },
        { name: '申请金额-仓储老客', value: fixedLimitRuleType?.oldStorageQuota || 0 },
        { name: '申请系数-标准系数', value: fixedLimitRuleType?.standardCoeff || 0 },
        { name: '申请系数-非标准系数', value: fixedLimitRuleType?.nonStandardCoeff || 0 }
      ]
    })

  fetchOverdue()
  fetchCredit()
}

const overdueAmountTypeRef = ref(1)

const overdueRef = ref({
  dateQueryType: 3,
  dataType: 'overdueRate',
  apiType: 1
})

const yearOverdue = ref<Dayjs>(dayjs())
const weakOverdue = ref<[Dayjs, Dayjs]>([dayjs().startOf('week').add(-13, 'week'), dayjs().startOf('week')])
const dayOverdue = ref<Dayjs>(dayjs().startOf('month'))
const overdueList = ref([])

//时间：天 选月 周 选两周期 月 选年
//业务员：天 选月 周 选两周期 月 选月
const fetchOverdue = () => {
  const p = {}
  p.customerRegionEmployeeNoList = formState.value.customerRegionEmployeeNoList
  p.dateQueryType = overdueRef.value.dateQueryType
  if (overdueRef.value.apiType === 1) {
    if (p.dateQueryType === 3) {
      p.startMonth = dayjs(yearOverdue.value).format('YYYY01')
      p.endMonth = dayjs(yearOverdue.value).format('YYYY12')
    } else if (p.dateQueryType === 2) {
      p.startWeek = dayjs(weakOverdue.value[0]).format('YYYYww')
      p.endWeek = dayjs(weakOverdue.value[1]).format('YYYYww')
    } else {
      p.startDay = dayjs(dayOverdue.value.startOf('month')).format('YYYY/MM/DD')
      p.endDay = dayjs(dayOverdue.value.endOf('month')).format('YYYY/MM/DD')
    }
  } else {
    if (p.dateQueryType === 3) {
      p.startDay = dayjs(yearOverdue.value).startOf('year').format('YYYY/MM/DD')
      p.endDay = dayjs(yearOverdue.value).endOf('year').format('YYYY/MM/DD')
    } else if (p.dateQueryType === 2) {
      p.startDay = dayjs(weakOverdue.value[0]).format('YYYY/MM/DD')
      p.endDay = dayjs(weakOverdue.value[1]).format('YYYY/MM/DD')
    } else {
      p.startDay = dayjs(dayOverdue.value.startOf('month')).format('YYYY/MM/DD')
      p.endDay = dayjs(dayOverdue.value.endOf('month')).format('YYYY/MM/DD')
    }
  }

  if (overdueRef.value.apiType === 1) {
    request.post<AxiosResult, AxiosResult>('/fbu/api/report/region/risk/overdueAmountListByTime', p).then((res) => {
      overdueList.value = generateOverdueList(p, res.data?.overdueList || [])
    })
  } else {
    request
      .post<AxiosResult, AxiosResult>('/fbu/api/report/region/risk/overdueAmountListByEmployeeNo', p)
      .then((res) => {
        overdueList.value = generateOverdueListByEmployeeNo(p, res.data?.overdueList || [])
      })
  }
}
const generateOverdueTips = (item: any) => {
  return overdueRef.value.dataType === 'overdueRate'
    ? `逾期率 <span style="font-weight: bolder;font-size: 16px">${item?.overdueRate || '0%'}</span>`
    : overdueRef.value.dataType === 'overdueAmount'
    ? `逾期金额 <span style="font-weight: bolder;font-size: 16px">${item?.overdueAmount || 0}</span>`
    : `逾期客户代码数 <span style="font-weight: bolder;font-size: 16px">${item?.overdueCustomer || 0}</span>`
}

const generateOverdueValue = (item: any) => {
  if (overdueRef.value.dataType === 'overdueRate') {
    return convertPercentageToNumber(item?.overdueRate)
  }

  return item?.[overdueRef.value.dataType] || 0
}
const generateOverdueListByEmployeeNo = (p: any, list: any) => {
  const datas = []
  props.formState.region.deptScopeInfo.forEach((employee: any) => {
    const item = list.find((ii: any) => ii.employeeNo === employee.employeeNo)
    const value = generateOverdueValue(item)
    datas.push({
      name: employee.employeeName,
      value: value,
      tooltip: `${employee.employeeName}<br>${generateOverdueTips(item)}`
    })
  })
  return datas
}
const generateOverdueList = (p: any, list: any) => {
  const datas = []
  if (p.dateQueryType === 3) {
    const year = dayjs(yearOverdue.value).startOf('month').format('YYYY')
    for (let i = 1; i <= 12; i++) {
      const item = list.find((ii: any) => ii.monthValue % 100 === i)
      const value = generateOverdueValue(item)
      datas.push({
        name: `${i}`,
        value: value,
        tooltip: `${year}/${String(i).padStart(2, '0')}<br>${generateOverdueTips(item)}`
      })
    }
  } else if (p.dateQueryType === 2) {
    let currentDay = dayjs(weakOverdue.value[0])
    const lastDay = dayjs(weakOverdue.value[1])

    while (currentDay.isBefore(lastDay.endOf('day')) || currentDay.isSame(lastDay.endOf('day'), 'day')) {
      const item = list.find((ii: any) => ii.weekValue === parseInt(currentDay.format('YYYYww')))
      // const quantity = item?.quantity || 0
      // const total = item?.total || 0
      const value = generateOverdueValue(item)
      datas.push({
        name: currentDay.format('YYYY-wo'),
        value: value,
        tooltip: `${currentDay.startOf('week').format('YYYY/MM/DD')}-${currentDay
          .endOf('week')
          .format('YYYY/MM/DD')}<br>${generateOverdueTips(item)}`
      })
      currentDay = currentDay.add(1, 'week')
    }
  } else {
    let currentDay = dayjs(dayOverdue.value.startOf('month'))
    const lastDay = dayjs(dayOverdue.value.endOf('month'))

    while (currentDay.isBefore(lastDay) || currentDay.isSame(lastDay, 'day')) {
      const item = list.find((ii: any) => ii.dayValue === currentDay.format('YYYY/MM/DD'))
      // const quantity = item?.quantity || 0
      // const total = item?.total || 0
      const value = generateOverdueValue(item)
      datas.push({
        name: currentDay.format('YYYY/MM/DD'),
        value: value,
        tooltip: `${currentDay.format('YYYY/MM/DD')}
          <br>${generateOverdueTips(item)}`
      })
      currentDay = currentDay.add(1, 'day')
    }
  }

  return datas
}

const creditRef = ref({
  dateQueryType: 3,
  dataType: 0,
  apiType: 1
})
const yearCredit = ref<Dayjs>(dayjs())
const weakCredit = ref<[Dayjs, Dayjs]>([dayjs().startOf('week').add(-13, 'week'), dayjs().startOf('week')])
const dayCredit = ref<Dayjs>(dayjs().startOf('month'))
const creditList = ref([])

const fetchCredit = () => {
  const p = {}
  p.customerRegionEmployeeNoList = formState.value.customerRegionEmployeeNoList
  p.dateQueryType = creditRef.value.dateQueryType
  if (creditRef.value.apiType === 1) {
    if (p.dateQueryType === 3) {
      p.startMonth = dayjs(yearCredit.value).format('YYYY01')
      p.endMonth = dayjs(yearCredit.value).format('YYYY12')
    } else if (p.dateQueryType === 2) {
      p.startWeek = dayjs(weakCredit.value[0]).format('YYYYww')
      p.endWeek = dayjs(weakCredit.value[1]).format('YYYYww')
    } else {
      p.startDay = dayjs(dayCredit.value.startOf('month')).format('YYYY/MM/DD')
      p.endDay = dayjs(dayCredit.value.endOf('month')).format('YYYY/MM/DD')
    }
  } else {
    if (p.dateQueryType === 3) {
      p.startDay = dayjs(yearCredit.value).startOf('year').format('YYYY/MM/DD')
      p.endDay = dayjs(yearCredit.value).endOf('year').format('YYYY/MM/DD')
    } else if (p.dateQueryType === 2) {
      p.startDay = dayjs(weakCredit.value[0]).format('YYYY/MM/DD')
      p.endDay = dayjs(weakCredit.value[1]).format('YYYY/MM/DD')
    } else {
      p.startDay = dayjs(dayCredit.value.startOf('month')).format('YYYY/MM/DD')
      p.endDay = dayjs(dayCredit.value.endOf('month')).format('YYYY/MM/DD')
    }
  }

  request
    .post<AxiosResult, AxiosResult>(
      creditRef.value.dataType === 1
        ? `/fbu/api/report/region/risk/${creditRef.value.apiType === 1 ? 'usedQuotaRateListByTime' : 'usedQuotaRateListByEmployeeNo'}`
        : `/fbu/api/report/region/risk/${creditRef.value.apiType === 1 ? 'creditCoefficientListByTime' : 'creditCoefficientListByEmployeeNo'}`,
      p
    )
    .then((res) => {
      creditList.value = (creditRef.value.apiType === 1 ? generateCreditList : generateCreditListByEmployeeNo)(p, res.data?.creditCoefficientList || res.data?.usedQuotaRateList || [])
    })
}

const generateCreditTips = (item: any) => {
  return creditRef.value.dataType === 1
    ? `已使用固定额度占比 <span style="font-weight: bolder;font-size: 16px">${item?.usedQuotaRate || '0%'}</span>`
    : `实际授信系数 <span style="font-weight: bolder;font-size: 16px">${item?.creditCoefficient || '0'}</span>`
}

const generateCreditListByEmployeeNo = (p: any, list: any) => {
  const datas = []
  props.formState.region.deptScopeInfo.forEach((employee: any) => {
    const item = list.find((ii: any) => ii.employeeNo === employee.employeeNo)
    const value = creditRef.value.dataType === 0 ? (item?.creditCoefficient || 0) : convertPercentageToNumber(item?.usedQuotaRate)
    datas.push({
      name: employee.employeeName,
      value: value,
      tooltip: `${employee.employeeName}<br>${generateCreditTips(item)}`
    })
  })
  return datas
}
const generateCreditList = (p: any, list: any) => {
  const datas = []
  if (p.dateQueryType === 3) {
    const year = dayjs(yearCredit.value).startOf('month').format('YYYY')
    for (let i = 1; i <= 12; i++) {
      const item = list.find((ii: any) => ii.monthValue % 100 === i)
      const value = creditRef.value.dataType === 0 ? (item?.creditCoefficient || 0) : convertPercentageToNumber(item?.usedQuotaRate)
      datas.push({
        name: `${i}`,
        value: value,
        tooltip: `${year}/${String(i).padStart(2, '0')}<br>${generateCreditTips(item)}`
      })
    }
  } else if (p.dateQueryType === 2) {
    let currentDay = dayjs(weakCredit.value[0])
    const lastDay = dayjs(weakCredit.value[1])

    while (currentDay.isBefore(lastDay.endOf('day')) || currentDay.isSame(lastDay.endOf('day'), 'day')) {
      const item = list.find((ii: any) => ii.weekValue === parseInt(currentDay.format('YYYYww')))
      // const quantity = item?.quantity || 0
      // const total = item?.total || 0
      const value = creditRef.value.dataType === 0 ? (item?.creditCoefficient || 0) : convertPercentageToNumber(item?.usedQuotaRate)
      datas.push({
        name: currentDay.format('YYYY-wo'),
        value: value,
        tooltip: `${currentDay.startOf('week').format('YYYY/MM/DD')}-${currentDay
          .endOf('week')
          .format('YYYY/MM/DD')}<br>${generateCreditTips(item)}`
      })
      currentDay = currentDay.add(1, 'week')
    }
  } else {
    let currentDay = dayjs(dayCredit.value.startOf('month'))
    const lastDay = dayjs(dayCredit.value.endOf('month'))

    while (currentDay.isBefore(lastDay) || currentDay.isSame(lastDay, 'day')) {
      const item = list.find((ii: any) => ii.dayValue === currentDay.format('YYYY/MM/DD'))
      // const quantity = item?.quantity || 0
      // const total = item?.total || 0
      const value = creditRef.value.dataType === 0 ? (item?.creditCoefficient || 0) : convertPercentageToNumber(item?.usedQuotaRate)
      datas.push({
        name: currentDay.format('YYYY/MM/DD'),
        value: value,
        tooltip: `${currentDay.format('YYYY/MM/DD')}
          <br>${generateCreditTips(item)}`
      })
      currentDay = currentDay.add(1, 'day')
    }
  }

  return datas
}

function convertPercentageToNumber(percentageString: string): number {
  if (!percentageString) {
    return 0
  }
  const noPercentage = percentageString.replace(/%/, '').replaceAll(',', '')
  return Number(noPercentage) / 100
}

import riseImage from '@/assets/rise.png'
import declineImage from '@/assets/decline.png'
const imageByCompare = (num1: number, num2: number) => {
  if (num1 > num2) {
    return '<img src="' + riseImage + '" class="icon icon-right" alt="" />'
  } else if (num1 < num2) {
    return '<img src="' + declineImage + '" class="icon icon-right" alt="" />'
  } else {
    return ''
  }
}

onMounted(() => {
  fetchData()
})
</script>
<script lang="ts">
export default {
  name: 'Tab4'
}
</script>
<style lang="scss" scoped>
@import './index.scss';

.padding-bg {
  padding: 16px;
}
</style>